import { render, staticRenderFns } from "./Voting.vue?vue&type=template&id=6c3efa73&scoped=true"
import script from "./Voting.vue?vue&type=script&lang=js"
export * from "./Voting.vue?vue&type=script&lang=js"
import style0 from "./Voting.vue?vue&type=style&index=0&id=6c3efa73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3efa73",
  null
  
)

export default component.exports